import payment from "../../api/payment";
import { dummyRows } from "@/common/functions";

const getDefaultState = () => {
  return {
    userData: {},
    paymentlist: [],
    totalCount: 0,
    stateLoad: false,
    lastSelectedPlanLoaded: false,
    cardsAndBillingInfoLoaded: false,
    loaded: false,
    planDetailsUpdated: false,
    newPlanDetails: {},
    noPlanSelected: "",
    lastSelectedPlan: {},
    paymentMethods: {},
    defaultCard: {},
    billingDetails: {
      companyName: "",
      address: "",
      city: "",
      state: "",
      county: "",
      zipcode: "",
      taxType: "",
      taxNumber: "",
    },
    plandetails: {
      plan: 1,
      subscriber: 0,
      email_per_month: 0,
      payNow: 0,
      email_per_day: 0,
      can_renew: 0,
      contact_support: 0,
      plan_type: 1,
      plan_amount: 0,
      expire: 0,
      currentSubscriber: 0,
      groupOf: 0,
      planTitle: "",
      enterpricePlan: 0,
      newPlan: {
        plan: 0,
      },
      currency: "usd",
    },
    currentPlanDetails: {
      canRestart: false,
    },
    planExpired: false,
    prevPlan: false,
    fromSignup: 0,
    accountStatus: "",
  };
};

// initial state
const state = getDefaultState();

const getters = {
  getPaymentCardCount: (state) => {
    var totalCount = 0;
    if (state.totalCount) {
      return state.totalCount;
    }

    return totalCount;
  },

  getPaymentCardList: (state) => {
    if (!state.loaded) {
      return dummyRows();
    }

    var array = [];

    if (state.paymentlist) {
      state.paymentlist.forEach(function (entry) {
        array.push({
          card_type: entry.cardType,
          card_number: entry.cardNumber,
          card_preference: entry.isDefault,
          card_action: entry.id,
        });
      });
    }

    return array;
  },
};

// actions
const actions = {
  addPaymentCard(_, params) {
    return payment.addPaymentCard(params);
  },
  cardnumberValidate(_, params) {
    return payment.cardnumberValidate(params);
  },

  fetOneCardDetails(_, params) {
    return payment.fetOneCardDetails(params);
  },

  setDefault(_, params) {
    return payment.setDefault(params);
  },
  deletePaymentCard(_, params) {
    return payment.deletePaymentCard(params);
  },

  paymentDetails({ commit }, params) {
    payment.paymentDetails(params, (data) => {
      commit("setLoaded", true);
      commit("setPaymentList", { items: data.paymentlist });
      commit("setPaymentListCount", { items: data.totallist });
    });
  },
  resetState({ commit }) {
    commit("resetState");
  },

  checkDefaultPayment(_, params) {
    return payment.checkDefaultPayment(params);
  },
  payMethod(_, params) {
    return payment.payMethod(params);
  },
  getExpired(_, params) {
    return payment.getExpired(params);
  },
  getPlanDetails({ commit }, params) {
    payment.getPlanDetails(params, (data) => {
      commit("setPlanDetails", data);
      commit("setPlanLoade", true);
    });
  },
  getLastSelectedPlan({ commit }, params) {
    payment.getLastSelectedPlan(params, (data) => {
      if (data.status !== "fail") {
        commit("setLastSelectedPlan", data);
      } else {
        commit("setNoPlanSelected", data.message);
      }
      commit("setLastSelectedPlanLoaded", true);
    });
  },
  setNewAuthToken(_, params) {
    return payment.setNewAuthToken(params);
  },
  setLastSelectedPlan(_, params) {
    return payment.setLastSelectedPlan(params);
  },
  getCurrentPlanDetails({ commit, state }, params) {
    if (!state.planExpired) {
      payment.getCurrentPlanDetails(params, (data) => {
        commit("setCurrentPlanDetails", data);
      });
    }
  },
  cancelSubScription(_, params) {
    return payment.cancelSubScription(params);
  },
  setRestartSubscription(_, params) {
    return payment.restartSubscription(params);
  },
  getSavedCards(_, params) {
    return payment.getSavedCards(params);
  },
  /* ,
  setLastSelectedPlan ({ commit, state }, params) {
    payment.setLastSelectedPlan(
      params,
      (data) => {
        commit('setLastSelectedPlan', data)
        commit('setLastSelectedPlanLoaded', true)
      }
    )
  } */
};

// mutations
const mutations = {
  setNewPlanDetails(state, items) {
    state.newPlanDetails = items;
    state.planDetailsUpdated = true;
  },
  setPlanDetailsUpdated(state, loaded) {
    state.planDetailsUpdated = loaded;
  },
  setPaymentList(state, { items }) {
    state.paymentlist = items;
    state.loaded = true;
  },
  setPaymentListCount(state, { items }) {
    state.totalCount = items;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setPlanLoade(state, loaded) {
    state.stateLoad = loaded;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setPlanDetails(state, data) {
    state.plandetails = data;
  },
  setNoPlanSelected(state, data) {
    state.noPlanSelected = data;
  },
  setLastSelectedPlan(state, data) {
    state.lastSelectedPlan = data.selectedPlan;
    state.billingDetails = data.billingDetails;
    state.paymentMethods = data.paymentMethods;
    state.defaultCard = data.defaultCard;
  },
  setCouponCode(state, data) {
    state.lastSelectedPlan = {
      ...data.selectedPlan,
      newCurrency: state.lastSelectedPlan.newCurrency,
      isDowngrade: state.lastSelectedPlan.isDowngrade,
      currencyChanged: state.lastSelectedPlan.currencyChanged,
    };
  },
  setLastSelectedPlanLoaded(state, loaded) {
    state.lastSelectedPlanLoaded = loaded;
  },
  setCurrentPlanDetails(state, data) {
    state.currentPlanDetails = data;
    state.planExpired = true;
    window.localStorage.setItem("currentPlanDetails", JSON.stringify(data));
  },
  setPlanExpire(state, data) {
    state.planExpired = data;
  },
  setPrevPlan(state, data) {
    state.prevPlan = data;
  },
  setFromSignup(state, data) {
    state.fromSignup = data;
  },
  setAccountStatus(state, data) {
    state.accountStatus = data;
  },
};
export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};
